import Types from "./Types";

export const listAttendenceForStudentRequest = (name) => ({
  type: Types.LIST_ATTENDENCE_FOR_STUDENT_REQUEST,
  payload: name,
});

export const listAttendenceForStudentSuccess = (data) => ({
  type: Types.LIST_ATTENDENCE_FOR_STUDENT_SUCCESS,
  payload: data,
});

export const listAttendenceForStudentFail = () => ({
  type: Types.LIST_ATTENDENCE_FOR_STUDENT_FAIL,
});

export const deleteAttendenceRequest = (id, action) => ({
  type: Types.DELETE_ATTENDENCE_REQUEST,
  payload: id,
  action,
});

export const deleteAttendenceSuccess = (id) => ({
  type: Types.DELETE_ATTENDENCE_SUCCESS,
  payload: id,
});

export const deleteAttendenceFail = () => ({
  type: Types.DELETE_ATTENDENCE_FAIL,
});

export const attendenceLoading = (isLoading) => ({
  type: Types.ATTENDENCE_LOADING,
  payload: isLoading,
});
